import {
    TableDataState,
    TableState,
    TblView,
    TblSort,
    TblFltStats,
    TblStats,
    TblPagination,
    TableFilters,
} from './table.types';

export function tableViewVM(): TblView {
    return {
        cols: [],
        sections: [],
        sort: tableSortVM(),
    };
}

export function tableSortVM(): TblSort {
    return {
        col: '',
        dir: '',
    };
}

export function tableFltStatsVM(): TblFltStats {
    return {
        filtered: 0,
        total: 0,
    };
}

export function tableStatsVM(): TblStats {
    return {
        fltStats: tableFltStatsVM(),
        paging: tablePaginationVM(),
    };
}

export function tablePaginationVM(): TblPagination {
    return {
        page: 1,
        size: 50,
        total: 0,
    };
}

export function tableFiltersVM(): TableFilters {
    return {};
}

// TABLE
export function tableStateVM(): TableState {
    return {
        init: true,
        waiting: false,
        views: [],
        currentViewId: '',
    };
}

// TABLE DATA
export function tableDataVM<TDataItem extends Record<string, any>>(data?: TDataItem[]): TableDataState<TDataItem> {
    return {
        dataItems: data && Array.isArray(data) ? data : [],
        items: [],
    };
}
